Object.defineProperty(exports,"__esModule",{value:true});exports.default=














sortedPositionsByState;var _securityDeviceArmState=require('../armState/securityDeviceArmState');var _armStateUtils=require('../armState/armStateUtils');var _securityDeviceHealthStatus=require('../healthStatus/securityDeviceHealthStatus');var _complianceState=require('../complianceState/complianceState');var _types=require('../complianceState/types');var _types2=require('../armState/types');var _helper=require('./helper');function sortedPositionsByState(positions){
var positionsWithStates=positions.map(function(p){var _positionStates=
(0,_helper.positionStates)(p),armState=_positionStates.armState,healthState=_positionStates.healthState,complianceState=_positionStates.complianceState;
return{
position:p,
armStatePriority:armStatePriority(armState),
healthStatePriority:(0,_securityDeviceHealthStatus.healthPriority)(healthState),
compliancePriority:compliancePriority(complianceState)};

});


var sorted=positionsWithStates.sort(function(p1,p2){
if(p1.armStatePriority===p2.armStatePriority){
if(p1.healthStatePriority===p2.healthStatePriority){
return p1.compliancePriority-p2.compliancePriority;
}

return p1.healthStatePriority-p2.healthStatePriority;
}

return p1.armStatePriority-p2.armStatePriority;
});

return sorted.map(function(el){return el.position;});
}





var armStatePriority=function armStatePriority(state){
if(!state){
return 4;
}

switch(state.type){
case _types2.armState.ALARMING:
return 1;
case _types2.armState.DISARMED:
return 2;
case _types2.armState.UNLOCKED:
return 3;
default:
return 4;}

};





var compliancePriority=function compliancePriority(state){
switch(state.type){
case _types.ComplianceStatus.COMPLIANT:
return 2;
case _types.ComplianceStatus.NON_COMPLIANT:
return 1;}

};